import { Link, useParams } from "react-router-dom";
import "../../styles.css";
import WheelComponent from "../../WheelComponent";
import GiftModal from "../../componenets/GiftModal";
import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { IoCaretBackCircleSharp } from "react-icons/io5";

function Wheel() {
  // const segments = ["2000", "5000", "2000", "5000"];
  const segments = ["3k", "5k", "10k"];
  // const segColors = [
  //   "#F0CF50",
  //   "#815CD1",
  //   "#F0CF50",
  //   "#815CD1",
  // ];
    const segColors = [
    "#F0CF50",
    "#815CD1",
    "#61d9f7ff",   
  ];
  const { data } = useParams();
  const [winnerData, setwinnerData] = useState();
  const [showGiftModal, setshowGiftModal] = useState(false);
  const [wheelSize, setWheelSize] = useState(240);  

  const handleClose = () => {
    setshowGiftModal(false);
  };

  const onFinished = (winner) => {
    // console.log(winner);
    setwinnerData(winner);
    setshowGiftModal(true);
  };

  useEffect(() => {
    const handleResize = () => {
      // For mobile devices (smaller than 768px)
      if (window.innerWidth < 768) {
        setWheelSize(245);
      } else {
        setWheelSize(190);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="App">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 d-flex justify-content-center align-items-center position-relative">
            <button
              className="btn btn-light rounded-pill px-4 fw-medium mt-3 spin-heading"
              // style={{backgroundColor:'#f0f5f5'}}
            >
              Spin & Win
            </button>
            <Link 
              className="mt-3 position-absolute end-0 " 
              style={{marginRight:"20px", cursor: "pointer", zIndex: 10}}
              to='/quiz'              
            >
              <IoCaretBackCircleSharp                
                fontSize={'32px'}                              
              />              
            </Link>                                           
          </div>
         

          {/* <div className="col-12 d-flex justify-content-center">
            <button
              className="btn btn-light rounded-pill px-4 fw-medium mt-3 spin-content-title"
              style={{ backgroundColor: "#dcedc8" }}
            >
              {data && data.replaceAll("_", "/")}
            </button>
          </div> */}

          <div
            className="col-12 d-flex justify-content-center"
            style={{ position: "relative", top: "-30px" }}
          >
            {/* <div className="col-12 d-flex justify-content-center"> */}
            <div id="wheelCircle">
              <WheelComponent
                segments={segments}
                segColors={segColors}
                winningSegment=""
                onFinished={(winner) => onFinished(winner)}
                primaryColor="black"
                primaryColoraround="#ffffffb4"
                contrastColor="white"
                buttonText="Spin"
                isOnlyOnce={false}
                size={wheelSize} //190
                upDuration={50} //50
                downDuration={1000} //1000
              />
            </div>
          </div>
        </div>
      </div>

      {/*Gift Modal*/}
      {
        <GiftModal
          show={showGiftModal}
          winnerData={winnerData}
          handleClose={handleClose}
          group={data.replaceAll("_", "/")}
        />
      }
    </div>
  );
}

export default Wheel;
